import type * as React from 'react';

import { cn } from '@/shared/lib/cn';

/** A pulsing placeholder block for loading states. Ported from the v1 design system. */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-accent', className)}
      {...props}
    />
  );
}

export { Skeleton };
